import { TableCellNumber } from '../../TableCellNumber'
import { TableCellBase } from '../TableCellBase'

function TableFloorCell({
  value,
  valuePrefix = 'Flat.FloorNumberKey',
  ...cellProps
}) {
  return (
    <TableCellBase {...cellProps}>
      <TableCellNumber value={value} valuePrefix={valuePrefix} />
    </TableCellBase>
  )
}

export default TableFloorCell
